module.exports = __webpack_public_path__ + "static/media/beauty-therapist-nannies-we-facilitate.3e8e72eb.jpg";